var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTodayIconLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 24.6521V45.6635C49.999 46.6862 49.5922 47.6667 48.8691 48.3899C48.1459 49.113 47.1654 49.5198 46.1427 49.5208H35.4488C34.4261 49.5198 33.4456 49.113 32.7225 48.3899C31.9993 47.6667 31.5926 46.6862 31.5915 45.6635V38.4741C31.592 37.8089 31.4614 37.1501 31.2071 36.5354C30.9527 35.9207 30.5797 35.3621 30.1093 34.8917C29.6389 34.4213 29.0803 34.0483 28.4656 33.7939C27.8509 33.5396 27.1921 33.409 26.5268 33.4095H23.5202C22.8549 33.409 22.1961 33.5396 21.5814 33.7939C20.9667 34.0483 20.4082 34.4213 19.9378 34.8917C19.4674 35.3621 19.0943 35.9207 18.84 36.5354C18.5856 37.1501 18.455 37.8089 18.4555 38.4741V45.6635C18.4545 46.6862 18.0477 47.6667 17.3246 48.3899C16.6014 49.113 15.6209 49.5198 14.5982 49.5208H3.85731C2.83461 49.5198 1.85409 49.113 1.13093 48.3899C0.407765 47.6667 0.00103775 46.6862 0 45.6635L0 24.6521C0.000221413 23.7592 0.178535 22.8752 0.524506 22.052C0.870477 21.2289 1.37716 20.4829 2.0149 19.8579L20.2979 1.91986C21.5544 0.689225 23.2432 0 25.002 0C26.7607 0 28.4495 0.689225 29.706 1.91986L47.989 19.8579C48.6255 20.4837 49.1311 21.2298 49.4764 22.0529C49.8216 22.876 49.9996 23.7596 50 24.6521Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTodayIconLight);
export default __webpack_public_path__ + "static/media/today-icon-light.f01704c83285a56bb2bd5e5be7999484.svg";
export { ForwardRef as ReactComponent };